import { MDCList } from '@material/list'
import { MDCRipple } from '@material/ripple'

export default {
  setup() {
    this.list = new MDCList(this.el)
    this.listItemRipples = this.list.listElements.map(
      (listItemEl) => new MDCRipple(listItemEl)
    )
    this.list.singleSelection = true
  },
  destroy() {
    this.listItemRipples?.forEach((listItemRipple) => listItemRipple.destroy())
    this.listItemRipples = null
    this.list?.destroy()
    this.list = null
  },
  mounted() {
    this.setup()
  },
  destroyed() {
    this.destroy()
  }
}
